import React, { FunctionComponent } from "react";
import { JoeAvailableReports } from "../../@types/joe";
import { route } from "../../../../shim/jsbridge";
import { Summary } from "../common/dynamicanalysis";

interface JoeAvailableReportsProps {
  hash?: string;
  uploadId?: string;
  reports?: JoeAvailableReports;
}

function sortAndMapReportToKeyValue(
  hash?: string,
  uploadId?: string,
  reports?: JoeAvailableReports
) {
  return Object.entries(reports ?? {})
    .sort(([, value1], [, value2]) => value1.order - value2.order)
    .map(([reportType, report]) => ({
      key: report.label + (reportType !== "screenshots" ? " Report" : ""),
      value: report.available ? (
        <a
          className="joe-report-download"
          href={
            hash
              ? route("api_joe_report_download", [hash, reportType])
              : route("api_joe_url_report_download", [uploadId, reportType])
          }
          target="_blank"
          rel="noreferrer"
        >
          Download <strong>{report.label}</strong>
        </a>
      ) : (
        "Report Unavailable"
      )
    }));
}

const JoeAvailableReports: FunctionComponent<JoeAvailableReportsProps> = ({
  reports,
  hash,
  uploadId
}) => <Summary items={sortAndMapReportToKeyValue(hash, uploadId, reports)} />;

export default JoeAvailableReports;
